module.exports = __webpack_public_path__ + "img/logo.fa422ecc.png";